import { useCurrentUser } from "APP_ROOT/hooks";
import T from "prop-types";

function MultiLocationFeature({ children }) {
  const currentUser = useCurrentUser();

  if (currentUser.locations.length > 1) {
    return children;
  }

  return null;
}

export default MultiLocationFeature;

MultiLocationFeature.propTypes = {
  children: T.oneOfType([T.node, T.arrayOf(T.node)])
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/MultiLocationFeature/MultiLocationFeature.jsx